import React from "react"
import { languages } from "../../../lib/languages"
import { CaretLeftOutlined } from "@ant-design/icons"
import { useNavigate } from "react-router"
import { useDispatch } from "react-redux"
import { HOME_PAGE } from "../../../core/constants"
interface PreviousButtonProps {
  onClick?: Function
  text?: string
  reset?: boolean
}

const PreviousButton: React.FC<PreviousButtonProps> = ({
  onClick,
  text,
  reset = false,
}) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const click = () => {
    if (reset) {
      dispatch({ type: "RESET_STORE" })
      navigate(HOME_PAGE)
    } else {
      onClick ? onClick() : navigate(-1)
    }
  }
  return (
    <span className="previous-link" onClick={click}>
      <CaretLeftOutlined />
      {text || languages.previous}
    </span>
  )
}

export default PreviousButton
